import {call, put} from 'redux-saga/effects';

import axios from 'axios';
import * as lexActionType from '../actionsType/lexRecommandedLearning.actionType';
import {getBaseUrl} from '../../../core/utility/filter.utility';

function getLexRecommandedLearning(cId) {
    // `${getBaseUrl()}/rest/lex/enrollUesrIntoLEX`
    // http://localhost:3001/enrollrest/lp/getRC
    return axios({
        method: 'post',
        url: `${getBaseUrl()}/rest/lp/getRC`,
        data: {
            cId: cId
        }
    });
    // return axios({
    //     method: 'get',
    //     url: 'http://localhost:9000/cont',
    //     data: reqObj
    // });
   // return axios.get('static/data/GetRecommendedContent.json');
}


export function* fetchLexRecommandedLearningSaga(request) {
    try {
        const response = yield call(getLexRecommandedLearning, request.payload);
        yield put({
            type: lexActionType.LEX_RECLEARN_SUCCESS,
            payload: response.data
        });
    } catch (error) {
        yield put({
            type: lexActionType.LEX_RECLEARN_ERROR,
            payload: 'There has been some issue with 3DS Learning Space. Please try after sometime.'
        });
    }
}
